module.exports = __webpack_public_path__ + "static/media/1-广联达BIM+智慧工地数据决策系统.d93c09b4.png";